import { FETCH_SUB_MENU_SUCCESS } from "./actionTypes";


const temp = [
  {
    path: `data:image/svg+xml;utf8,${encodeURIComponent(`
        <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 250 105"
  width="250"
  height="105"
  preserveAspectRatio="none"
  style="display: block; border-radius: 4px;"
>
  <defs>
    <!-- Define a shimmer gradient -->
    <linearGradient id="shimmerGradient" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="#e0e0e0" />
      <stop offset="20%" stop-color="#e0e0e0" />
      <stop offset="50%" stop-color="#f5f5f5" />
      <stop offset="80%" stop-color="#e0e0e0" />
      <stop offset="100%" stop-color="#e0e0e0" />
    </linearGradient>

    <!-- Shimmer mask using animated gradient slide -->
    <mask id="shimmerMask">
      <g>
        <!-- Base mask background -->
        <rect x="0" y="0" width="250" height="105" fill="#fff" />
        <!-- Moving shimmer -->
        <rect x="-250" y="0" width="250" height="105" fill="url(#shimmerGradient)">
          <animateTransform
            attributeName="transform"
            type="translate"
            from="-250 0"
            to="250 0"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
    </mask>
  </defs>

  <!-- Image placeholder with shimmer animation -->
  <rect width="250" height="105" fill="#e0e0e0" mask="url(#shimmerMask)" />
</svg>

        `)}`
  },
  {
    path: `data:image/svg+xml;utf8,${encodeURIComponent(`
                <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 250 105"
  width="250"
  height="105"
  preserveAspectRatio="none"
  style="display: block; border-radius: 4px;"
>
  <defs>
    <!-- Define a shimmer gradient -->
    <linearGradient id="shimmerGradient" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="#e0e0e0" />
      <stop offset="20%" stop-color="#e0e0e0" />
      <stop offset="50%" stop-color="#f5f5f5" />
      <stop offset="80%" stop-color="#e0e0e0" />
      <stop offset="100%" stop-color="#e0e0e0" />
    </linearGradient>

    <!-- Shimmer mask using animated gradient slide -->
    <mask id="shimmerMask">
      <g>
        <!-- Base mask background -->
        <rect x="0" y="0" width="250" height="105" fill="#fff" />
        <!-- Moving shimmer -->
        <rect x="-250" y="0" width="250" height="105" fill="url(#shimmerGradient)">
          <animateTransform
            attributeName="transform"
            type="translate"
            from="-250 0"
            to="250 0"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
    </mask>
  </defs>

  <!-- Image placeholder with shimmer animation -->
  <rect width="250" height="105" fill="#e0e0e0" mask="url(#shimmerMask)" />
</svg>
        `)}`
  },
  {
    path: `data:image/svg+xml;utf8,${encodeURIComponent(`
                <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 250 105"
  width="250"
  height="105"
  preserveAspectRatio="none"
  style="display: block; border-radius: 4px;"
>
  <defs>
    <!-- Define a shimmer gradient -->
    <linearGradient id="shimmerGradient" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="#e0e0e0" />
      <stop offset="20%" stop-color="#e0e0e0" />
      <stop offset="50%" stop-color="#f5f5f5" />
      <stop offset="80%" stop-color="#e0e0e0" />
      <stop offset="100%" stop-color="#e0e0e0" />
    </linearGradient>

    <!-- Shimmer mask using animated gradient slide -->
    <mask id="shimmerMask">
      <g>
        <!-- Base mask background -->
        <rect x="0" y="0" width="250" height="105" fill="#fff" />
        <!-- Moving shimmer -->
        <rect x="-250" y="0" width="250" height="105" fill="url(#shimmerGradient)">
          <animateTransform
            attributeName="transform"
            type="translate"
            from="-250 0"
            to="250 0"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
    </mask>
  </defs>

  <!-- Image placeholder with shimmer animation -->
  <rect width="250" height="105" fill="#e0e0e0" mask="url(#shimmerMask)" />
</svg>
        `)}`
  },

  {
    path: `data:image/svg+xml;utf8,${encodeURIComponent(`
                <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 250 105"
  width="250"
  height="105"
  preserveAspectRatio="none"
  style="display: block; border-radius: 4px;"
>
  <defs>
    <!-- Define a shimmer gradient -->
    <linearGradient id="shimmerGradient" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="#e0e0e0" />
      <stop offset="20%" stop-color="#e0e0e0" />
      <stop offset="50%" stop-color="#f5f5f5" />
      <stop offset="80%" stop-color="#e0e0e0" />
      <stop offset="100%" stop-color="#e0e0e0" />
    </linearGradient>

    <!-- Shimmer mask using animated gradient slide -->
    <mask id="shimmerMask">
      <g>
        <!-- Base mask background -->
        <rect x="0" y="0" width="250" height="105" fill="#fff" />
        <!-- Moving shimmer -->
        <rect x="-250" y="0" width="250" height="105" fill="url(#shimmerGradient)">
          <animateTransform
            attributeName="transform"
            type="translate"
            from="-250 0"
            to="250 0"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
    </mask>
  </defs>

  <!-- Image placeholder with shimmer animation -->
  <rect width="250" height="105" fill="#e0e0e0" mask="url(#shimmerMask)" />
</svg>
        `)}`
  },
  {
    path: `data:image/svg+xml;utf8,${encodeURIComponent(`
                <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 250 105"
  width="250"
  height="105"
  preserveAspectRatio="none"
  style="display: block; border-radius: 4px;"
>
  <defs>
    <!-- Define a shimmer gradient -->
    <linearGradient id="shimmerGradient" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="#e0e0e0" />
      <stop offset="20%" stop-color="#e0e0e0" />
      <stop offset="50%" stop-color="#f5f5f5" />
      <stop offset="80%" stop-color="#e0e0e0" />
      <stop offset="100%" stop-color="#e0e0e0" />
    </linearGradient>

    <!-- Shimmer mask using animated gradient slide -->
    <mask id="shimmerMask">
      <g>
        <!-- Base mask background -->
        <rect x="0" y="0" width="250" height="105" fill="#fff" />
        <!-- Moving shimmer -->
        <rect x="-250" y="0" width="250" height="105" fill="url(#shimmerGradient)">
          <animateTransform
            attributeName="transform"
            type="translate"
            from="-250 0"
            to="250 0"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
    </mask>
  </defs>

  <!-- Image placeholder with shimmer animation -->
  <rect width="250" height="105" fill="#e0e0e0" mask="url(#shimmerMask)" />
</svg>
        `)}`
  },
  {
    path: `data:image/svg+xml;utf8,${encodeURIComponent(`
                <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 250 105"
  width="250"
  height="105"
  preserveAspectRatio="none"
  style="display: block; border-radius: 4px;"
>
  <defs>
    <!-- Define a shimmer gradient -->
    <linearGradient id="shimmerGradient" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="#e0e0e0" />
      <stop offset="20%" stop-color="#e0e0e0" />
      <stop offset="50%" stop-color="#f5f5f5" />
      <stop offset="80%" stop-color="#e0e0e0" />
      <stop offset="100%" stop-color="#e0e0e0" />
    </linearGradient>

    <!-- Shimmer mask using animated gradient slide -->
    <mask id="shimmerMask">
      <g>
        <!-- Base mask background -->
        <rect x="0" y="0" width="250" height="105" fill="#fff" />
        <!-- Moving shimmer -->
        <rect x="-250" y="0" width="250" height="105" fill="url(#shimmerGradient)">
          <animateTransform
            attributeName="transform"
            type="translate"
            from="-250 0"
            to="250 0"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
    </mask>
  </defs>

  <!-- Image placeholder with shimmer animation -->
  <rect width="250" height="105" fill="#e0e0e0" mask="url(#shimmerMask)" />
</svg>
        `)}`
  },
  {
    path: `data:image/svg+xml;utf8,${encodeURIComponent(`
                <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 250 105"
  width="250"
  height="105"
  preserveAspectRatio="none"
  style="display: block; border-radius: 4px;"
>
  <defs>
    <!-- Define a shimmer gradient -->
    <linearGradient id="shimmerGradient" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="#e0e0e0" />
      <stop offset="20%" stop-color="#e0e0e0" />
      <stop offset="50%" stop-color="#f5f5f5" />
      <stop offset="80%" stop-color="#e0e0e0" />
      <stop offset="100%" stop-color="#e0e0e0" />
    </linearGradient>

    <!-- Shimmer mask using animated gradient slide -->
    <mask id="shimmerMask">
      <g>
        <!-- Base mask background -->
        <rect x="0" y="0" width="250" height="105" fill="#fff" />
        <!-- Moving shimmer -->
        <rect x="-250" y="0" width="250" height="105" fill="url(#shimmerGradient)">
          <animateTransform
            attributeName="transform"
            type="translate"
            from="-250 0"
            to="250 0"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
    </mask>
  </defs>

  <!-- Image placeholder with shimmer animation -->
  <rect width="250" height="105" fill="#e0e0e0" mask="url(#shimmerMask)" />
</svg>
        `)}`
  },
  {
    path: `data:image/svg+xml;utf8,${encodeURIComponent(`
                <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 250 105"
  width="250"
  height="105"
  preserveAspectRatio="none"
  style="display: block; border-radius: 4px;"
>
  <defs>
    <!-- Define a shimmer gradient -->
    <linearGradient id="shimmerGradient" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="#e0e0e0" />
      <stop offset="20%" stop-color="#e0e0e0" />
      <stop offset="50%" stop-color="#f5f5f5" />
      <stop offset="80%" stop-color="#e0e0e0" />
      <stop offset="100%" stop-color="#e0e0e0" />
    </linearGradient>

    <!-- Shimmer mask using animated gradient slide -->
    <mask id="shimmerMask">
      <g>
        <!-- Base mask background -->
        <rect x="0" y="0" width="250" height="105" fill="#fff" />
        <!-- Moving shimmer -->
        <rect x="-250" y="0" width="250" height="105" fill="url(#shimmerGradient)">
          <animateTransform
            attributeName="transform"
            type="translate"
            from="-250 0"
            to="250 0"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
    </mask>
  </defs>

  <!-- Image placeholder with shimmer animation -->
  <rect width="250" height="105" fill="#e0e0e0" mask="url(#shimmerMask)" />
</svg>
        `)}`
  }
];



const initialState = {
  data: temp,
};

const submenuListR = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUB_MENU_SUCCESS:
      console.log("Fetching media info from API. If delayed, default images will be used.");
      const updatedData = action.payload.response || temp;
      if (!action.payload.response) {
        console.log("API response delayed or unavailable. Loading default images.");
      }
      return { ...state, data: updatedData };
    default:
      return state;
  }
}

export default submenuListR